/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes */
if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

function hasNumber(string) {
    return /\d/.test(string);
}

function isSafeNumber(value) {
    return typeof value === 'number';
}

/* format number to have commas for thousandths */
/* !!note: this method renders negative numbers into positive */
Number.prototype.formatNumber = function (nDecimals, decimalMark, thousandsSep) {
    var _this = Math.abs(Number(this) || 0);
    nDecimals = isNaN(nDecimals = Math.abs(nDecimals)) ? 2 : nDecimals;
    decimalMark = decimalMark === undefined ? '.' : decimalMark;
    thousandsSep = thousandsSep === undefined ? ',' : thousandsSep;
    var s = _this < 0 ? '-' : '';
    var i = String(parseInt(_this.toFixed(nDecimals)));
    var j = (j = i.length) > 3 ? j % 3 : 0;
    return s +
        (j ? i.substr(0, j) + thousandsSep : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep) +
        (nDecimals ? decimalMark + Math.abs(_this - i).toFixed(nDecimals).slice(2) : '');
};


function jumpTo(element) {
    element = $(element) || false;
    /* if element exists on page */
    if (element.length) {
        /* get dimensions of header */
        const padding = 80;
        $('html,body').animate({
            scrollTop: element.offset().top - padding
        }, 600);

        /* apply focus to input to prompt help panel */
        element.focus();
    } else {
        /* jump to top if element not provided */
        $('html,body').animate({
            scrollTop: $('body').offset().top
        }, 600);
    }
}

function getJSON(url) {
    var promise = fetch(url)
        .then(function (response) {
            // Handle the fetch Response object.

            if (!response.ok) {
                // Non-200-status response; throw here so it is handled in the catch.
                throw response;
            }

            // OK response, return the data.
            // Use text() instead of json() so we don't fail if json is not available.
            return response.text();
        })
        .then(function (text) {
            // Safely convert the response text to json.
            try {
                var json = JSON.parse(text);
                return json;
            } catch (e) {
                throw new Error('Failed to parse JSON: {1}'.format(text));
            }
        })
        .catch(function (err) {
            // Handle all types of errors in one place.

            if (err instanceof Response) {
                // The response was not successful (status not in the range 200-299). From `throw response` in the first .then chain above.
                throw new Error('Unexpected response ({1}): {2}'.format(err.status, err.statusText));
            } else {
                // fetch() failed, such as network failure, or the JSON failed to parse.
                throw new Error('Exception: {1}'.format(err.message));
            }
        });

    return promise;
}

/* https://docs.djangoproject.com/en/dev/ref/csrf/#ajax */
// function getCookie(name) {
//     let cookieValue = null;
//     if (document.cookie && document.cookie !== '') {
//         const cookies = document.cookie.split(';');
//         for (let i = 0; i < cookies.length; i++) {
//             const cookie = cookies[i].trim();
//             // Does this cookie string begin with the name we want?
//             if (cookie.substring(0, name.length + 1) === (name + '=')) {
//                 cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
//                 break;
//             }
//         }
//     }
//     return cookieValue;
// }